import * as actions from './actions'

const initState = {
    userId: null,
    customerId: null
}

export default function reducer(state = initState, action) {
    switch(action.type) {
        case actions.USER_REGISTER_SUCCESS:
            return {
                ...state,
                ...{
                    userId: action.userId
                }
            }
        case actions.CUSTOMER_REGISTER_SUCCESS:
            return {
                ...state,
                ...{
                    customerId: action.customerId
                }
            }
        default:
            return state
    }
}
